<template>
  <div>
    <top-nav></top-nav>
    <div class="center_container">
      <div class="crumb">首页 / 赛事报名</div>

      <div class="filter_con">
        <div class="f_item">
          <div class="f_label">赛事项目</div>
          <div class="f_val">
            <div :class="{'s_item': currentItemIndex === 0}"
                 class="v_item" @click="selectClick(0)">
              所有项目
            </div>
            <div v-for="(item, index) in eventItems" :key="index" :class="{'s_item': currentItemIndex === item.id}"
                 class="v_item" @click="selectClick(item.id)">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="f_item">
          <div class="f_label">赛事时间</div>
          <div class="f_val">
            <div v-for="(item, index) in eventTimes" :key="index" :class="{'s_item': currentTimeIndex === index}"
                 class="v_item" @click="timeSelect(index)">
              {{ item }}
            </div>
            <el-date-picker
                v-model="eventTimeRange"
                end-placeholder="结束日期" format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                style="margin-bottom: 10px"
                type="daterange"
                value-format="yyyy-MM-dd"
                @change="timeChange">
            </el-date-picker>
          </div>
        </div>
        <div class="f_item">
          <div class="f_label">报名状态</div>
          <div class="f_val">
            <div v-for="(item, index) in registrationStatus" :key="index"
                 :class="{'s_item': registrationStatusIndex === index}"
                 class="v_item" @click="bmClick(index)">
              {{ item }}
            </div>
          </div>
        </div>
      </div>

      <!--      <el-tabs v-model="activeName" style="margin-top: 25px">-->
      <!--&lt;!&ndash;        <el-tab-pane label="最新上架" name="1"></el-tab-pane>&ndash;&gt;-->
      <!--        <el-tab-pane label="比赛时间" name="1"></el-tab-pane>-->
      <!--      </el-tabs>-->

      <div class="s_list">
        <div v-for="item in eventList" :key="item.id" class="s_con">
          <div class="s_item" @click="toDetail(item)">
            <div class="s_img">
              <img :src="fileUrl + item.imageUrl" alt="">
            </div>
            <div class="s_info">
              <div class="text_overflow s_name">{{ item.name }}</div>
              <div>开赛时间：{{ item.gameStartTime }}</div>
              <div class="s_money">报名费用：<span :title="moneyChange(item.entriesList)" class="money_style">{{
                  moneyChange(item.entriesList)
                }}</span>元
              </div>
              <div class="s_type">{{ item.eventName }}</div>
              <br>
              <el-button :disabled="item.status === 3" class="s_btn" type="primary">立即报名
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="display_flex" style="justify-content: center">
        <el-pagination
            :total="total"
            background
            layout="prev, pager, next"
            @current-change="currentChange">
        </el-pagination>
      </div>
    </div>
    <bot-nav></bot-nav>
  </div>
</template>

<script>
import { FILE_API } from "@/Settings";

export default {
  name: "eventActivities",
  data () {
    return {
      fileUrl: FILE_API,
      // 赛事项目
      eventItems: [''],
      currentItemIndex: 0, // 当前赛事项目下标
      // 赛事时间
      eventTimes: ['全部', '本周', '下周', '本月', '下月'],
      currentTimeIndex: 0, // 当前赛事时间下标
      eventTimeRange: null,
      // 报名状态
      registrationStatus: ['全部', '未开始', '进行中', '已结束'],
      registrationStatusIndex: 0, // 当前报名状态下标

      activeName: '0',

      // 赛事列表
      eventList: [],
      gameStartTime: '',
      gameEndTime: '',
      total: 0,
      current: 1
    }
  },
  created () {
    this.projectAjax()
    this.getManagementPage()
  },
  methods: {
    moneyChange (list) {
      let arr = []
      if (list && list.length > 0) {
        list.forEach((val) => {
          arr.push(val.price)
        })
      }

      return '￥' + arr.join('/')
    },
    // 分页
    currentChange (e) {
      this.current = e
      this.getManagementPage()
    },
    // 报名状态
    bmClick (index) {
      this.registrationStatusIndex = index
      this.getManagementPage()
    },
    // 时间选择
    timeChange (e) {
      if (e.length > 0) {
        this.gameStartTime = e[0]
        this.gameEndTime = e[1]
      } else {
        this.gameStartTime = ''
        this.gameEndTime = ''
      }

      this.getManagementPage()
    },
    // 时间筛选
    selectClick (id) {
      this.currentItemIndex = id
      this.getManagementPage()
    },
    //时间筛选
    timeSelect (index) {
      this.currentTimeIndex = index
      this.getManagementPage()
    },
    toDetail (item) {
      this.$router.push({
        path: '/eventDetails',
        query: {
          item: JSON.stringify(item)
        }
      })
    },
    projectAjax () {
      this.$postAction('gateway/event-table/list').then((res) => {
        this.eventItems = res.data

      })
    },
    getManagementPage () {
      this.$postAction('gateway/event-management/getManagementPage', {
        "page": {
          "current": this.current,
          "size": 10
        },
        "data": {
          "type": this.currentTimeIndex,
          "keyword": "",
          "eventId": this.currentItemIndex,
          "applicationStatus": this.registrationStatusIndex,
          "gameStartTime": this.gameStartTime,
          "gameEndTime": this.gameEndTime
        }
      }).then((res) => {
        this.eventList = res.data.records
        this.total = res.data.total
      })
    }

  }
}
</script>

<style lang="less" scoped>
.center_container {
  padding-bottom: 40px;
}

.s_money {
  display: flex;
  align-items: center;
}

.money_style {
  display: inline-block;
  overflow: hidden;
  width: 100px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.s_item {
  transition: all linear .2s;
  cursor: pointer;

  .s_img img {
    transition: all linear .2s;
  }

  &:hover {
    transition: all linear .2s;

    .s_img img {
      transform: scale(1.2);
      transition: all linear .2s;
    }

    .s_name {
      color: #0058A6;
    }
  }
}

.s_img {
  height: 264px;
}
</style>
